import * as yup from 'yup';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _values from 'lodash/values';

import { Row, RenderConfig, TextInput, SelectInput } from 'commons-ui';
import { REJECT_REASONS } from '../../constants';

const FORM_FIELD_KEYS = {
	SELECTED_MESSAGE: 'selectedMessage',
	OTHER_MESSAGE: 'otherMessage'
};

const otherMessageDependencyResolver = (props: any, dependencyValues: any) => {
	const selectedMessage = _get(dependencyValues, '0');
	const { disabled } = props;

	if (selectedMessage === REJECT_REASONS.OTHER && disabled) {
		return { disabled: false };
	}
	if (selectedMessage !== REJECT_REASONS.OTHER && !disabled) {
		return { disabled: true };
	}
	return null;
};

export const validationSchema = yup.object().shape({
	selectedMessage: yup.string().required('message is a required field'),
	otherMessage: yup.string().when(['selectedMessage'], {
		is: REJECT_REASONS.OTHER,
		then: yup.string().required('Reason is a required field').min(10).max(60)
	})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SELECTED_MESSAGE]: new RenderConfig()
		.setName('selectedMessage')
		.setLabel('Reason')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: _map(_values(REJECT_REASONS), (reason) => ({ id: reason, label: reason }))
		}),
	[FORM_FIELD_KEYS.OTHER_MESSAGE]: new RenderConfig()
		.setName('otherMessage')
		.setLabel('Other Reason')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			dependencies: ['selectedMessage'],
			dependencyResolver: otherMessageDependencyResolver
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.SELECTED_MESSAGE), new Row(FORM_FIELD_KEYS.OTHER_MESSAGE)];
